import Api from "../helpers/api";

export const vratStav = async () => {
  try {
    const response = await Api.get(`/api/v1/smartmap/state`);
    return response.data && response.data.user_id ? response.data : false;
  } catch (error) {
    return false;
  }
};

export const ulozStav = async (stav) => {
  try {
    const response = await Api.post(`/api/v1/smartmap/state`, stav);
    return response.data && response.data.user_id ? response.data : false;
  } catch (error) {
    return false;
  }
};
